
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.33 6.042c.105.097.237.286.3.622l.01.048c.652 2.833 1.637 6.778 2.392 9.806.517 2.071.927 3.713 1.05 4.276.258 1.416 1.462 2.708 3.11 2.708h11.991c2.407 0 4.433-1.73 4.989-4.084l1.904-8.067a2.292 2.292 0 00-.382-1.883 2.166 2.166 0 00-1.742-.89H7.547c-.207-.856-.398-1.664-.563-2.382-.303-1.558-1.47-2.677-2.929-2.677H1.863v2.4h2.192c.072 0 .171.026.276.123zm3.743 4.7l-.526-2.163c.167.696.345 1.424.526 2.162z","fill":"#1F4FFF"}}),_c('path',{attrs:{"d":"M11.836 26.513a1.968 1.968 0 113.936.001 1.968 1.968 0 01-3.936 0zM20.448 26.513a1.968 1.968 0 113.936.001 1.968 1.968 0 01-3.936 0z","fill":"#1F4FFF"}})])
          )
        }
      }
    